import SectionHeader from "@/components/base/SectionHeader";

const values = [
  {
    icon: "ri-sparkling-2-line",
    title: "内容为先",
    desc: "只聚合公开合法的娱乐内容，坚持真实、有看点的信息筛选。",
  },
  {
    icon: "ri-slideshow-4-line",
    title: "体验至上",
    desc: "分类与时长筛选顺手，追更进度清晰，找视频不用来回折腾。",
  },
  {
    icon: "ri-verified-badge-line",
    title: "靠谱可信",
    desc: "每条内容标注分类与时长，公开来源，让吃瓜更安心。",
  },
];

const testimonials = [
  {
    name: "阿茶",
    role: "追剧达人",
    quote: "平时就爱刷名场面，这里按类型和时长一筛就有，通勤路上看短集锦特别方便。",
  },
  {
    name: "小北",
    role: "综艺爱好者",
    quote: "深度专题会讲幕后逻辑，比单纯刷片段有意思多了，每周都在追更。",
  },
  {
    name: "林一",
    role: "媒体从业者",
    quote: "分类清晰、内容定位明确，找素材的时候能很快定位到需要的公开片段。",
  },
];

export default function About() {
  return (
    <section id="about" className="w-full bg-background-50 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <SectionHeader
            eyebrow="关于我们"
            title="做一个把吃瓜变简单的视频站"
            subtitle="吃瓜视频在线从“想看点什么却不知从哪看起”这个念头出发，把分散的公开娱乐内容按类型与时长整理成一座好逛的视频库。我们相信，看内容不应该是件费劲的事。"
          />
          <div className="mt-8 flex flex-col gap-5">
            {values.map((v) => (
              <div key={v.title} className="flex items-start gap-4 rounded-xl border border-background-200/70 bg-background-100/60 p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                  <i className={`${v.icon} text-xl`} />
                </span>
                <div>
                  <h3 className="text-base font-bold text-foreground-950">{v.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-5 lg:col-span-7">
          <div className="grid grid-cols-3 gap-3 rounded-2xl border border-background-200/70 bg-background-100/60 p-6 md:p-8">
            {[
              { num: "10w+", label: "内容积累" },
              { num: "5 大", label: "分类板块" },
              { num: "24h", label: "滚动更新" },
            ].map((s) => (
              <div key={s.label} className="flex flex-col items-center gap-1 text-center">
                <span className="font-heading text-2xl text-primary-600 md:text-3xl">{s.num}</span>
                <span className="text-xs text-foreground-500">{s.label}</span>
              </div>
            ))}
          </div>

          <div className="rounded-2xl border border-background-200/70 bg-background-100/60 p-6 md:p-8">
            <div className="flex items-center gap-2 text-sm font-bold tracking-wide text-primary-600">
              <i className="ri-chat-heart-line text-base" />
              来自吃瓜群众的口碑
            </div>
            <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
              {testimonials.map((t) => (
                <figure key={t.name} className="flex flex-col gap-3 rounded-xl bg-background-50 p-4">
                  <div className="flex gap-0.5 text-accent-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm" />
                    ))}
                  </div>
                  <blockquote className="text-sm leading-relaxed text-foreground-700">“{t.quote}”</blockquote>
                  <figcaption className="flex items-center gap-2 border-t border-background-200/70 pt-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-700">
                      {t.name.slice(0, 1)}
                    </span>
                    <span className="flex flex-col">
                      <span className="text-sm font-bold text-foreground-950">{t.name}</span>
                      <span className="text-xs text-foreground-500">{t.role}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>

          <div className="flex flex-col items-start justify-between gap-4 rounded-2xl bg-primary-500 p-6 md:flex-row md:items-center md:p-8">
            <div>
              <h3 className="font-heading text-xl text-background-50">想第一时间收到更新？</h3>
              <p className="mt-1 text-sm text-background-100">订阅吃瓜速递，重要内容不再错过。</p>
            </div>
            <a
              href="#contact"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-5 py-2.5 text-sm font-bold text-primary-600 transition-colors hover:bg-accent-100"
            >
              <i className="ri-notification-3-line" />
              立即订阅
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}